module.exports = __webpack_public_path__ + "static/21-lessons-for-the-21st-century-23bf8df51bdb126c9a48cd5bef74ac73.jpg";